import { Toast } from 'vant'

import {
    newsBase,
    ticketBase,
    AuthorizationBASE,
    PersonalBaseURL,
    VolunteerBaseURL
} from './ipConfig';

import http from '@js/http-token.js';
import store from '../../store/index';
//  获取token
export const getTokenUrl = AuthorizationBASE + '/hnbwgcms/wechart/common/api/openIdVerify';

export const getWechatApiUrl = AuthorizationBASE + `/hnbwgcms/wechart/common/api/getWechatApiUrl`;

//  获取openId
export const getOpenIdUrl = AuthorizationBASE + `/hnbwgcms/wechart/common/api/getOpenId`;
//  测试环境
export const getTestOpenIdUrl = newsBase + '/museum_hn/api/guestUser/getOpenId.html';

// https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3b17402f48814f8f&redirect_uri=http://192.168.1.106:8080&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect

//  检查用户是否绑定手机
// export const checkUserIsBindPhoneUrl = newsBase + '/museum_hn/api/guestUser/bindPhoneVerify.html';

//  用户绑定手机号码
export const bindPhoneByOpenIdUrl = newsBase + '/museum_hn/api/guestUser/bindPhoneByOpenId.html';

// 2020.11.19 update userInfo
export const updateUserInfoUrl = newsBase + `/hnbwgcms/wechart/common/api/updateUserInfo`

//  用户修改手机号码接口
export const updateBindPhoneUrl = newsBase + '/museum_hn/api/guestUser/updateBindPhone.html';

//  发送手机验证码
export const sendSMSVerifyCodeUrl = newsBase + '/museum_hn/api/common/sendSMSVerifyCode.html';

//  通过openId获取用户信息
export const getInfoByOpenIdUrl = newsBase + '/museum_hn/api/guestUser/getInfoByOpenId.html';
// 个人中心相关
export const getTicketUrl = PersonalBaseURL + '/api/appointment';
export const getActivitytUrl = PersonalBaseURL + '/api/activity';
// 志愿者相关
// 参加活动
export const getVolunteerJointUrl = VolunteerBaseURL + '/index/join';
// 排班
export const getVolunteerSchetUrl = VolunteerBaseURL + '/index/sche';
// 志愿者个人信息
export const getVolunteerUserInfo = VolunteerBaseURL + '/index/userinfo';

//  PV次数
export function addNumberOfVisits(url) {
    http.get(`${newsBase}/hnbwgcms/visit_log`, { params: { url, referrer: 'weixin' }, loading: false })
        .then(res => {
            console.log(res)
        })
        .catch(error => {
            console.error(error)
        })
}

export async function getOpenId() {

    var isProduction = process.env.NODE_ENV === "production";
    const locaOpenId = sessionStorage.getItem('temp-set-open-id') || '';
    //  本地以及有openId的时候 网页刷新使用openId更新用户信息
    if (locaOpenId) {
        getUserInfoByOpenId(locaOpenId);
    } else {
        var hrefStr = window.location.href,
            array = hrefStr.split('code=') || [],
            wxCode = '';
        console.log(hrefStr);
        //  获取地址栏code
        if (hrefStr.includes('code=') && array.length > 0) {
            wxCode = String(array[1]).split('&state=')[0];
        } else {
            window.localStorage.setItem('redirectUri', hrefStr.split('#')[1]);
            //  生产环境 获取跳转地址 并跳转微信认证
            let href = hrefStr.split('#')[0];
            let redirectUri = href.substr(0, href.length - 1)
            console.log(redirectUri);
            // var {
            //     data: {
            //         data: {
            //             wechatApiUrl = ''
            //         }
            //     }
            // } = await http.post(getWechatApiUrl, { redirectUri })
            let appid = 'wx4907af0fa372dec3';
            let scope = 'snsapi_userinfo';
            let state = getState()
            console.log(state, '--');
            let wechatApiUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`

            if (wechatApiUrl && isProduction) {
                window.location.replace(wechatApiUrl)
            }
        }
        if (wxCode) {
            window.localStorage.setItem('secondIn', 1);
            //  通过微信code获取openId 及其用户信息
            try {
                var { data: {
                    data: userInfo = {}
                } } = await http.post(getOpenIdUrl, { wxCode })
                if (userInfo?.openId ?? '') {
                    //  换了新的用户
                    if (locaOpenId !== userInfo.openId) {
                        sessionStorage.clear();
                    }
                    store.commit('setOpenId', userInfo.openId);
                    store.commit('setUserInnerInfo', userInfo);
                    store.commit('setUserId', userInfo.userId);
                    getToken();
                }
            } catch (error) {
                console.error('获取用户信息失败')
            }
        }
        if (isProduction) return

        http.post(getTestOpenIdUrl).then(res => {
            var {
                data: {
                    data
                }
            } = res;
            if (data.openId) {
                const locaOpenId = sessionStorage.getItem('temp-set-open-id') || '';
                //  换了新的用户
                if (locaOpenId !== data.openId) {
                    sessionStorage.clear();
                }
                store.commit('setUserInnerInfo', data);
                store.commit('setUserId', data.userId);
                store.commit('setOpenId', data.openId);
                getToken();
            }
        })

    }

}

function getState() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

// export function checkUserIsBindPhone(openId) {
//     http.post(checkUserIsBindPhoneUrl, { openId }).then(res => {
//         var {
//             data: {
//                 data: {
//                     // 1-已绑定，0-未绑定	
//                     flag
//                 }
//             }
//         } = res;
//         var tempFlag = flag === 0 ? false : true;
//         // var tempFlag = false;
//         // console.log('检查用户是否绑定手机号,1-已绑定，0-未绑定',flag)
//         store.commit('setIsBind', tempFlag);
//         // if (tempFlag) {
//         //     getUserInfoByOpenId(openId);
//         // }
//     })
// }
export function getUserInfoByOpenId(openId) {
    let userInfo = JSON.parse(sessionStorage.getItem('temp-set-user-detail-info'))
    if (!userInfo) getOpenId();
    store.commit('setUserInnerInfo', userInfo);
    store.commit('setUserId', userInfo.userId);
    // http.post(getInfoByOpenIdUrl, { openId }).then(res => {
    //     var {
    //         data: {
    //             data: userInfo
    //         },
    //         success = true
    //     } = res;
    //     if (success) {
    //         // userInfo.isVolunteer = 2;
    //         // console.log(userInfo)
    //         //  isVolunteer 是否是志愿者（0-否，1-是）	
    //         store.commit('setUserInnerInfo', userInfo);
    //         store.commit('setUserId', userInfo.userId);
    //         // store.commit('setUserId', '123');
    //     }
    // })
}
export function getToken() {
    if (!store.state.userInfo.openId) return;
    http.post(getTokenUrl, {
        openId: store.state.userInfo.openId
    }).then(res => {
        var {
            data: {
                data: {
                    accessToken
                }
            }
        } = res;
        console.log(accessToken);
        if (accessToken) {
            sessionStorage.setItem('volunteer-token', accessToken);
            // checkUserIsBindPhone(store.state.userInfo.openId);
            store.commit('setIsReadyOk', true);
        }
    })
}

export function updateToken(response) {
    let {
        headers: {
            access_token = ''
        },
        config: {
            headers: {
                access_token: access_token2 = ''
            }
        }
    } = response;
    if (access_token === '') {
        access_token = access_token2;
    }
    if (access_token) {
        sessionStorage.setItem('volunteer-token', access_token);
    }
}

//  拼接票务模块的图片资源
export function tokenImage(url) {
    return `${ticketBase}${url}`
}


//  超时
export function timeoutFc(error) {
    console.log(error)
    var tips = ''
    if (error.message.includes('timeout')) {
        tips = "请求超时,请稍后再试";
    } else {
        tips = "数据获取失败";
    }
    // setTimeout(() => {
    Toast.fail(tips)
    // }, 400);
    return Promise.reject(error);
}